<!--
 * @Author: name
 * @Date: 2022-07-13 15:57:51
 * @Description: 
-->
<template>
  <div class="solutions">
    <section class="parallax-background mobile-display background fadeIn">
      <span class="white--text title-label font-weight-medium">{{
        $t("i18n.solutions")
      }}</span>
    </section>
    <section id="service">
      <div class="py-8"></div>
      <v-container class="text-center">
        <!-- <h3 class="font-weight-medium mb-3 item-title">{{$t('i18n.service')}}</h3> -->
        <v-responsive class="mx-auto mb-4" width="56"></v-responsive>
        <v-responsive
          class="mx-auto font-weight-regular text-justify"
          max-width="1200"
          style="color: #000; text-indent: 2em; font-size: 20px"
          >{{ $t("i18n.solintro") }}</v-responsive
        >
      </v-container>
    </section>
    <!--解决方案-->
    <section id="cases">
      <v-container class="text-center">
        <v-divider
          style="margin-right: 30% !important; margin-left: 30% !important"
        ></v-divider>
        <v-responsive class="mx-auto mb-6" width="56"></v-responsive>
        <v-row v-for="({ img, title, text, text2 }, i) in $t('i18n.soldatas')" :key="i">
          <v-col>
            <v-card class="mx-auto solcard">
              <v-row style="margin: 0">
                <v-col cols="12" md="4"
                  ><v-img cover class="img" :src="img"></v-img
                ></v-col>
                <v-col
                  ><v-card-title>{{ title }}</v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="sol-text">{{ text }}</v-card-text>
                  <v-card-text class="sol-text"
                    ><span style="font-weight: bold">{{
                      $t("i18n.refpro")
                    }}</span
                    >{{ text2 }}</v-card-text
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div class="py-8"></div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: null,
      page: 1,
      pageCount: 0,
      currentData: [],
    };
  },
  mounted() {
    var hash = window.location.hash;
    var index = hash.lastIndexOf("#");
    if (index != -1) {
      var id = hash.substring(index + 1, hash.length + 1);
      var div = document.getElementById(id);
      if (div) {
        div.scrollIntoView();
      }
    }
  },
  methods: {
    change(index) {
      this.window = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.background {
  background: url(../assets/images/common/banner4.jpg);
  background-size: cover;
}

.tabs {
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
}
.active_tab {
  color: rgb(0, 0, 0) !important;
  font-size: 30px;
  text-decoration: none;
}
.content {
  // border: 1px solid #019fe8 !important;
  border-radius: 0px !important;
  min-height: 660px;
}
/* .content-light:hover {
  box-shadow: #019fe8 0 0 15px;
} */
.case-title {
  background: #019fe8;
  color: #fff !important;
  padding: 10px;
  font-size: 20px;
  font-weight: 500;
}
.active-title {
  background: #019fe8;
  color: #fff !important;
}
// .v-list-item {
//   border: 1px solid #019fe8;
// }
// .v-list {
//   padding: 0px;
// }
.data-title {
  background: #019fe8;
  color: #fff;
  padding: 10px;
  font-size: 20px;
  font-weight: 500;
}
.solcard {
  overflow: hidden;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 0px;
  border: 1px solid #bebebe !important;
  box-shadow: 0 0 black;
  padding: 10px;
  .img {
    border-radius: 0 !important;
  }
  .sol-text {
    text-align: left;
    width: fit-content;
    margin-right: 0px;
    padding: 5px;
  }
  .sol-btn {
    color: #019fe8;
  }
}
.solcard:hover {
  border: 1px solid #019fe8 !important;
}
</style>
